'use strict';
// var baseUrl = 'http://wap.osports.cn/live/api';

var baseUrl = 'https://running.osports.cn/biqu';
var baseImg = 'https://running.osports.cn/biqu';
// var baseUrl = 'https://running.osports.cn/biqu_dev';
// var baseImg = 'https://running.osports.cn/biqu_dev';

// var baseUrl = 'https://running.osports.cn/live/api';
// var baseImg = 'https://running.osports.cn/live';
// const baseUrl = 'http://192.168.1.74:8080/live';
// const baseUrl = 'http://192.168.1.120:8080/live';


function imgUrl(src) {
  if (typeof src != 'undefined' && src.indexOf('http') == -1) {
    return baseImg + src;
  }else{
    return src;
  }
}
function imgUrlL(list,item) {
  if (typeof list != 'undefined' && list.length >0) {
    for(var i = 0;i<list.length;i++){
      list[i][item] = baseImg + list[i][item];
    }
    return list;
  }else{
    return list;
  }
}

module.exports = {
  baseUrl: baseUrl,
  baseImg: baseImg,
  imgUrl: imgUrl,
  imgUrlL: imgUrlL,
}



// WEBPACK FOOTER //
// ./static/util/domain.js